/**
 * Header component
 * Handles burger button toggle and menu visibility
 */
export class Header {
	/**
	 * Initializes the header logic by selecting relevant DOM elements
	 * and binding event listeners.
	 */
	constructor() {
		/** @type {HTMLElement|null} */
		this.burgerButton = document.querySelector('.site-header__burger');

		/** @type {HTMLElement|null} */
		this.ctaButton = document.querySelector('.site-header__cta-button');

		/** @type {HTMLElement|null} */
		this.menuContainer = document.querySelector('.site-header__menu');

		// Exit if burger button is not found
		if (!this.burgerButton) return;

		this.burgerButton.addEventListener('click', () => this.toggle());
	}

	/**
	 * Toggles the active state of the burger button,
	 * the CTA button, and the navigation menu.
	 */
	toggle() {
		const isActive = this.burgerButton.classList.toggle('is-active');

		if (this.ctaButton) {
			this.ctaButton.classList.toggle('is-visible', isActive);
		}

		if (this.menuContainer) {
			this.menuContainer.classList.toggle('is-visible', isActive);
		}
	}
}
